import { ElementRef, InjectionToken } from '@angular/core';

export const PRIZM_SCROLL_REF = new InjectionToken<ElementRef<HTMLElement>>('Scrollable container');
